import { render } from "./trading-rules.vue?vue&type=template&id=28f54fde&scoped=true"
import script from "./trading-rules.vue?vue&type=script&lang=js"
export * from "./trading-rules.vue?vue&type=script&lang=js"

import "./trading-rules.vue?vue&type=style&index=0&id=28f54fde&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/home_website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f54fde"]])

export default __exports__